import React from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';
import { LISTING_BRANDS } from '../../../constants/listing.constants';
import { Dropdown, ValidationError } from '../../../components';

import css from './BrandDropdownField.module.css';

const BrandDropdownField = props => {
  const intl = useIntl();

  return (
    <Field {...props}>
      {fieldRenderProps => {
        const { input, meta, label, currentOptionMessageId } = fieldRenderProps;

        return (
          <div className={css.root}>
            {label && <label>{label}</label>}
            <Dropdown
              {...input}
              dropdownInputClassName={css.dropdownInput}
              search={input.value}
              onSearch={input.onChange}
              filterType="includes"
              currentOptionMessageId={currentOptionMessageId}
              options={LISTING_BRANDS}
              placeholder={intl.formatMessage({ id: 'BrandDropdownField.placeholder' })}
            />
            <ValidationError fieldMeta={meta} />
          </div>
        );
      }}
    </Field>
  );
};

export default BrandDropdownField;
